export const BASE_URL = import.meta.env.VITE_BASE_URL;

export const USER = {
  LOGIN: `${BASE_URL}/users/login`,
  PROFILE: `${BASE_URL}/users/:id`,
  RESET_PASSWORD: `${BASE_URL}/users/resetpassword`,
};

export const BANNER = `${BASE_URL}/banners/web_live_scoring_free`;

export const BOWLING_CENTERS = {
  ALL: `${BASE_URL}/bowlingcenters`,
  SINGLE: `${BASE_URL}/bowlingcenters/:uuid`,
};

export const LIVESCORING = {
  LIVE: `wss://${BASE_URL}/livescoring`,
  FINISHED: `/bowlingcenters/:uuid/completed/:page`,
  SEARCH_FINISHED: `/scorecards/blocks/search`,
  TOP_SCORES: `/bowlingcenters/:uuid/leaderboards`,
};
